export const initialBasicInfo = {
  firstName: "Jane",
  lastName: "Doest",
  email: "jane.doest@mainsource.org",
  phone: "708 930 3820",
  countryCode: "+234",
  countryFlag: "🇳🇬",
  country: "Nigeria",
  city: "Lagos",
};

export const COUNTRY_OPTIONS = [
  "Nigeria",
  "Ghana",
  "Kenya",
  "South Africa",
  "Other",
];

export const initialAccess = {
  team: "", // empty -> view renders "No team yet", matching the original
  role: "Admin",
  position: "Recruiter",
  department: "Talent Acquisition",
};

export const ROLE_OPTIONS = ["Admin", "Manager", "Member", "Viewer"];

export const accountDetails = {
  memberSince: "March 12, 2023",
  lastLogin: "Today at 9:41 AM",
  status: "Active",
  accountId: "AWA-2023-JD-00419",
};

export const PERMISSIONS = [
  { label: "Post Jobs", granted: true },
  { label: "View Candidates", granted: true },
  { label: "Send Messages", granted: true },
  { label: "Manage Team", granted: true },
  { label: "Billing Access", granted: true },
  { label: "Delete Company", granted: false },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    initials: "KA",
    bg: "var(--navy)",
    name: "Kemi Adeyemi",
    role: "HR Manager · Admin",
  },
  {
    id: 2,
    initials: "TO",
    bg: "#1d4ed8",
    name: "Tunde Okafor",
    role: "Recruiter · Member",
  },
  {
    id: 3,
    initials: "AL",
    bg: "#10b981",
    name: "Amaka Lawal",
    role: "Sourcer · Member",
  },
];

export const SESSIONS = [
  {
    id: 1,
    device: "Windows PC · Chrome 124",
    meta: "Lagos, Nigeria · Active now",
    current: true,
  },
  {
    id: 2,
    device: "iPhone 15 · Safari",
    meta: "Lagos, Nigeria · 2 hours ago",
    current: false,
  },
  {
    id: 3,
    device: "iPad Pro · Safari",
    meta: "Abuja, Nigeria · 3 days ago",
    current: false,
  },
];

export const SECURITY_TIPS = [
  {
    tone: "good",
    text: "Use a password manager and never reuse passwords across services.",
  },
  {
    tone: "warn",
    text: "Change your password every 90 days and avoid using personal information.",
  },
];

export const SECURITY_SCORE = {
  value: 82,
  max: 100,
  label: "Good",
  hint: "Set up authenticator app to reach 100",
};

// Ported from the Email Notifications card's toggle list.
export const EMAIL_NOTIF_PREFS = [
  {
    id: "newApplicants",
    label: "New Applicants",
    desc: "Get notified when someone applies to your job posts",
    defaultChecked: true,
  },
  {
    id: "messages",
    label: "Messages",
    desc: "Receive an email for each new message in your inbox",
    defaultChecked: true,
  },
  {
    id: "jobExpiry",
    label: "Job Expiry Reminders",
    desc: "Alert 3 days before a job post expires",
    defaultChecked: true,
  },
  {
    id: "billing",
    label: "Subscription & Billing",
    desc: "Invoices, renewals and payment confirmations",
    defaultChecked: true,
  },
  {
    id: "weeklyDigest",
    label: "Weekly Digest",
    desc: "Summary of your activity every Monday morning",
    defaultChecked: false,
  },
  {
    id: "productUpdates",
    label: "Product Updates",
    desc: "News about new Awasource features and improvements",
    defaultChecked: false,
  },
];

// Ported from the Push & In-App Notifications card's toggle list.
export const PUSH_NOTIF_PREFS = [
  {
    id: "candidateStatus",
    label: "Candidate Status Change",
    desc: "When a candidate moves through your pipeline",
    defaultChecked: true,
  },
  {
    id: "newMessage",
    label: "New Message Received",
    desc: "Instant notification for incoming messages",
    defaultChecked: true,
  },
  {
    id: "teamActivity",
    label: "Team Activity",
    desc: "Actions taken by team members on shared jobs",
    defaultChecked: false,
  },
];

export const PW_STRENGTH_LEVELS = [
  { width: "0%", colour: "transparent", label: "Enter a new password" },
  { width: "25%", colour: "#dc2626", label: "Weak" },
  { width: "50%", colour: "#f59e0b", label: "Fair" },
  { width: "75%", colour: "#3b82f6", label: "Good" },
  { width: "100%", colour: "#10b981", label: "Strong — great choice!" },
];
